import { render, staticRenderFns } from "./LKS01.vue?vue&type=template&id=126235b6"
import script from "./LKS01.vue?vue&type=script&lang=js"
export * from "./LKS01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports